/**
 * @author Ariel
 * @description 培训中心列表页面配置
 * @Date 2020/5/26
 * @update 管理人员组件回显完成 2020/5/29
 */
import React from 'react'
import {WizTableForm} from "../../common";

const userConfig = WizTableForm.Config.user(this, {apiParams: {state: 1}})
//配置项
let componentName = 'trainCenter'
const columns = [
  {
    name: 'id',
    formItem: {
      type: "hidden"
    }
  },
  {
    title: "培训中心名称",
    name: "name",
    searchItem: {},
    tableItem: {
      width: 300,
    },
    formItem: {
      maxLength: 30,
      placeholder: '最多输入30个字',
      rules: [{
        required: true,
        message: '请输入培训中心名称'
      }]
    },
  },
  {
    title: "地址",
    name: "address",
    tableItem: {
      width: 400,
    },
    formItem: {
      type:"textarea",
      maxLength: 80,
      placeholder: '最多输入80个字'
    },
  },
  {
    title: "创建时间",
    name: "createTime",
    tableItem: {}
  }
];

const templateConfig = {
  mainProps: {},
  content: {
    name: "WizTableList",
    params: {
      columns,
      searchBarProps: {
        buttonSort: ['add'],
        collapse: false
      },
      modalFormProps: {},
      dataTableProps: {
        rowKey: "id",
        isScroll: true,
        loading: false
      },
      rowOperateSort: ['update'],
      rowOperateView: []
    }
  }
};

const apis = {
  list: {
    path: `${componentName}/list`,
    payload: {
      key: `${componentName}@list`,
      apiParams: {}
    }
  },
  add: {
    path: `${componentName}/add`,
    payload: {
      key: `${componentName}@add`,
      apiParams: {}
    }
  },
  update: {
    path: `${componentName}/update`,
    payload: {
      key: `${componentName}@update`,
      apiParams: {}
    }
  }
}

let reduxTemplateCofig = (args) => {
  return {
    apis,
    componentName,
    initApiKeys: ['list'],
    needLoading: true,
    ...args
  }
};

export {reduxTemplateCofig, templateConfig};
